export default __webpack_public_path__ + "static/media/agenda1.7d3ea004.jpg";